import PropTypes from 'prop-types';

import usePuids from 'core/hooks/usePuids';

import PuidsContext from '.';


function PuidsProvider({ children, puids: puidsProp, link }) {
  const puids = usePuids(link, puidsProp);

  return (
    <PuidsContext.Provider value={puids}>
      {children}
    </PuidsContext.Provider>
  );
}

PuidsProvider.propTypes = {
  /** Данные, которые следует использовать вместо запроса из апи */
  puids: PropTypes.object,

  /** Урл из location.pathname */
  link: PropTypes.string,
};

export default PuidsProvider;
